module.exports = __webpack_public_path__ + "img/叶坪中华苏维埃共和国临时中央政府电话总机室旧址.23e9939e.png";